// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1wKFU","options":"AnswerScale_options__2A3eC","selected":"AnswerScale_selected__VVfw7"};